import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Products from './Products';
import { data, dataSync } from './data.js';
import { searchProducts } from '../services/productFeedService';
import './SearchResults.css';
import AffiliateBanners from './AffiliateBanners';

const SearchResults = () => {
  const location = useLocation();
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const query = queryParams.get('q');
    
    if (query) {
      setSearchTerm(query);
      performSearch(query);
    }
  }, [location.search]);

  const performSearch = async (term) => {
    setIsLoading(true);
    
    try {
      console.log(`Searching for "${term}" in real product feed...`);
      // Try to search in the real product feed
      const results = await searchProducts(term);
      console.log(`Search for "${term}" returned ${results.length} real products`);
      setSearchResults(results);
    } catch (error) {
      console.error('Search error:', error);
      // Fallback to static data search
      const staticProducts = dataSync();
      const filtered = staticProducts.filter(product => 
        product.productName.toLowerCase().includes(term.toLowerCase()) ||
        product.brand.toLowerCase().includes(term.toLowerCase()) ||
        product.description.toLowerCase().includes(term.toLowerCase())
      );
      console.log(`Fallback search returned ${filtered.length} static products`);
      setSearchResults(filtered);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      performSearch(searchTerm.trim());
    }
  };

  return (
    <div className="search-results">
      <div className="search-header">
        <h1>Sökresultat</h1>
        <form className="search-form" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Sök efter bilar, märken eller modeller..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button type="submit" className="search-button">
            Sök
          </button>
        </form>
      </div>
      {/* Only show banner if there are search results */}
      {searchResults.length > 0 && <AffiliateBanners type="small" />}

      {isLoading ? (
        <div className="loading">
          <p>Söker efter produkter...</p>
        </div>
      ) : (
        <>
          {searchResults.length > 0 ? (
            <div className="search-info">
              <p>Hittade {searchResults.length} produkt{searchResults.length !== 1 ? 'er' : ''} för "{searchTerm}"</p>
            </div>
          ) : searchTerm ? (
            <div className="no-results">
              <h3>Inga produkter hittades</h3>
              <p>Prova att söka efter andra ord eller kolla våra kategorier.</p>
            </div>
          ) : null}

          {searchResults.length > 0 && (
            <div className="search-products">
              {searchResults.map((product) => (
                <div key={product.productId} className="search-product-item">
                  <img src={product.image} alt={product.productName} />
                  <div className="product-info">
                    <h3>{product.productName}</h3>
                    <p className="brand">{product.brand}</p>
                    <p className="price">{product.price} kr</p>
                    <p className="description">{product.description}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SearchResults;
